import {OLVIDO_PASS_TYPES} from '../constants/olvidoPass.types'
import {olvidoPassInitialState} from '../initital-state/olvidoPass.state'
import {OlvidoPass, OlvidoPassAction, OlvidoPassState} from '../interfaces/olvidoPass.interface'

const olvidoPassReducer = (
  state: OlvidoPass = olvidoPassInitialState,
  action: OlvidoPassAction
): OlvidoPassState => {
  switch (action.type) {
    case OLVIDO_PASS_TYPES.FORM_RESTABLECER_HANDLE_CHANGE:
      return {...state, formRestablecer: {...state.formRestablecer, ...action.payload}}
    case OLVIDO_PASS_TYPES.FORM_VERIFICAR_HANDLE_CHANGE:
      return {...state, formVerificar: {...state.formVerificar, ...action.payload}}
    case OLVIDO_PASS_TYPES.FORM_PASSWORD_HANDLE_CHANGE:
      return {...state, formPassword: {...state.formPassword, ...action.payload}}
    case OLVIDO_PASS_TYPES.FORM_PASSWORD_ADD_ERRORS:
      return {...state, errorFormPassword: {...state.errorFormPassword, ...action.payload}}
    case OLVIDO_PASS_TYPES.CLEAR:
      return olvidoPassInitialState
    default:
      return state
  }
}

export default olvidoPassReducer
